<template>
	<el-dialog :visible.sync="waitRechargeVisible" class="wait-recharge-dialog" title="充值提示" append-to-body>
		<i class="el-icon-warning-outline w-icon-tips" />
		<p class="w-tips">充值完成前，请不要关闭当前支付验证弹窗。</p>
		<p class="w-tips">支付成功后，点击下方支付成功按钮。</p>
		<div slot="footer">
			<el-button @click="waitRechargeVisible = false"> 关闭 </el-button>
			<el-button type="primary" class="primary-button" @click="waitRechargeVisible = false"> 支付完成 </el-button>
		</div>
	</el-dialog>
</template>

<script>
import { RECHARGE_SUCCESS } from '@/constant';

export default {
	props: {
		visible: {
			required: true,
		},
	},
	computed: {
		waitRechargeVisible: {
			get() {
				return this.visible;
			},
			set(val) {
				this.$emit('update');
				this.$emit('update:visible', val);
			},
		},
	},
	mounted() {
		window.addEventListener('message', this.receiveMessage, false);
	},
	beforeDestroy() {
		window.removeEventListener('message', this.receiveMessage);
	},
	methods: {
		receiveMessage(event) {
			// const origin = event.origin || event.originalEvent.origin;
			if (event.data && event.data.type == RECHARGE_SUCCESS) {
				this.$emit('update');
			}
		},
	},
};
</script>
<style lang="less">
.wait-recharge-dialog {
	.el-dialog {
		width: 580px;
	}
	.el-dialog__header {
		padding: 20px;
		border-bottom: 1px solid #d8dbe0;
	}
	.el-dialog__body {
		position: relative;
		padding: 30px 55px;
		min-height: 80px;
	}
	.w-icon-tips {
		position: absolute;
		font-size: 36px;
		color: #ff4b40;
	}
	.w-tips {
		padding: 0 24px;
		margin-left: 30px;
		font-size: 18px;
		color: #5d6574;
		& + .w-tips {
			margin-top: 10px;
		}
	}
}
</style>
